import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { afterItems, beforeItems } from '../../data/comparison';
export function BeforeAfter() {
  return <section className="bg-mist px-5 py-16 sm:py-20" aria-label="Before and after" data-id="element-87" data-mp="26k9x8i6avbby">
      <div className="mx-auto max-w-6xl" data-id="element-88" data-mp="22mc4j5dbm73t">
        <SectionHeading title={<>
              From scattered information to <span className="text-electric" data-id="element-90" data-mp="2ubxes9ho9a1k">structured clinical reasoning</span>
            </>} data-id="element-89" data-mp="2zaryrerdl4n9" />

        <div className="mt-10 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-91" data-mp="2q9u2jin6i1f8">
          <div className="flex flex-col rounded-3xl border-2 border-alert/25 bg-white p-6 sm:p-8" data-id="element-92" data-mp="2qc6i5p5grzp4">
            <div className="flex items-center gap-3" data-id="element-93" data-mp="2ldlgdlakd7yk">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-alert text-white" data-id="element-94" data-mp="1ew86remtd1kq">
                <XIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-95" data-mp="19uiqnkkqhxps" />
              </span>
              <div data-id="element-96" data-mp="175vuwt4p1pkf">
                <p className="font-display text-2xl font-black uppercase leading-none text-alert" data-id="element-97" data-mp="1739ncthsza27">Before</p>
                <p className="mt-1 text-sm font-semibold text-ink/60" data-id="element-98" data-mp="1c233ktoh5f62">Maxillary Growth Blueprint™</p>
              </div>
            </div>
            <ul className="mt-6 divide-y divide-alert/10" data-id="element-99" data-mp="132zixl9nsrpg">
              {beforeItems.map(item => <li key={item} className="flex gap-3 py-3.5 text-[15px] leading-snug text-ink/80" data-id="element-100" data-mp="oemhw9vpsio3">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-101" data-mp="t5us384vc82b" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col rounded-3xl bg-navy-950 p-6 text-white sm:p-8" data-id="element-102" data-mp="jgtflrxj88t3">
            <div className="flex items-center gap-3" data-id="element-103" data-mp="5fqqt7f5kkeh">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-success text-white" data-id="element-104" data-mp="5i3g65n8px1k">
                <CheckIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-105" data-mp="agy2hhkf23qf" />
              </span>
              <div data-id="element-106" data-mp="27dkix7sf64ka">
                <p className="font-display text-2xl font-black uppercase leading-none text-gold" data-id="element-107" data-mp="27d0xhh3k8y1i">After</p>
                <p className="mt-1 text-sm font-semibold text-white/65" data-id="element-108" data-mp="23b5zomku92sh">Studying the Blueprint™</p>
              </div>
            </div>
            <ul className="mt-6 divide-y divide-white/10" data-id="element-109" data-mp="1yefgvrhnft3d">
              {afterItems.map(item => <li key={item} className="flex gap-3 py-3.5 text-[15px] font-medium leading-snug text-white" data-id="element-110" data-mp="2v2c1r8k4dake">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-111" data-mp="2qzfcx03zki80" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-112" data-mp="1ana1fdfmf2tl">
          <p className="text-lg text-ink/75" data-id="element-113" data-mp="1aol75ismmknc">You don’t need more disconnected information.</p>
          <p className="mt-1 font-display text-2xl font-black leading-tight text-navy-950 sm:text-3xl" data-id="element-114" data-mp="15mm5qegg5xt1">
            You need a clearer way to organize what you’re learning.
          </p>
        </div>

        <div className="mt-8" data-id="element-115" data-mp="10jv4fapefci2">
          <CtaButton label="Yes! I want the clinical roadmap" data-id="element-116" data-mp="15ig2b3h6hk3c" />
        </div>
      </div>
    </section>;
}